import Images from "../../../assets";

export const mockFacets = {
  categories: [
    { id: "6", name: "Espresso Machines", count: 0 },
    { id: "7", name: "Coffee Filters", count: 0 },
    { id: "11", name: "Pour Over Kits", count: 0 },
    { id: "5", name: "Coffee Scales", count: 0 },
    { id: "12", name: "Tea Kettles", count: 0 },
    { id: "2", name: "Thermos & Tumblers", count: 0 },
  ],
  products: [
    { id: "1", name: "Espresso Makers", count: 0 },
    { id: "2", name: "Φίλτρα", count: 0 },
    { id: "3", name: "Pour Over", count: 0 },
    { id: "4", name: "Scales", count: 0 },
    { id: "5", name: "Kettles", count: 0 },
    { id: "6", name: "Tumblers", count: 0 },
  ],
  brands: [
    { id: "17", name: "Acaia", count: 0 },
    { id: "18", name: "Aeropress", count: 0 },
    { id: "19", name: "Asobu", count: 0 },
    { id: "20", name: "Fellow", count: 0 },
    { id: "17", name: "Ecoffee", count: 0 },
    { id: "21", name: "ivykin", count: 0 },
    { id: "9", name: "Hario", count: 0 },
    { id: "9", name: "Lodge", count: 0 },
    { id: "9", name: "Chemex", count: 0 },
  ],
  colors: [
    { id: "2", name: "Μπλε", hex: "#1E90FF", count: 0 },
    { id: "1", name: "Γκρι", hex: "#888888", count: 0 },
    { id: "4", name: "Μαύρο", hex: "#000000", count: 0 },
    { id: "3", name: "Λευκό", hex: "#FFFFFF", count: 0 },
    { id: "6", name: "Πράσινο", hex: "#2E7D32", count: 0 },
  ],
  price: { min: 0, max: 3000 },
};

// export const mockProductsData = [
//   {
//     id: "p1",
//     name: "Stainless Steel Wine Chiller (VPB1)",
//     brand: "acaia",
//     category: "espresso-machines",
//     color: "black",
//     price: 27.2,
//     originalPrice: 29.0,
//     specialOffer: true,
//     badge: "SPECIAL OFFER",
//     image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Roasted_coffee_beans.jpg/1200px-Roasted_coffee_beans.jpg" // local uploaded file
//   },
//   {
//     id: "p2",
//     name: "AeroPress Go Coffee Maker",
//     brand: "aeropress",
//     category: "espresso-machines",
//     color: "red",
//     price: 38.9,
//     originalPrice: null,
//     specialOffer: false,
//     image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=0b6f7b1a5d3cb8b0a6b8f8f2f2b79f2a"
//   },
//   {
//     id: "p3",
//     name: "Asobu Pour Over Kit",
//     brand: "asobu",
//     category: "pour-over",
//     color: "gray",
//     price: 69.0,
//     originalPrice: 79.0,
//     specialOffer: true,
//     badge: "SPECIAL OFFER",
//     image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQO9TfIFqT5Np6d9CSiJB0QdXnOGE2NPaOXGQ&s"
//   },
//   {
//     id: "p4",
//     name: "Fellow Stagg EKG Kettle",
//     brand: "fellow",
//     category: "tea-kettles",
//     color: "black",
//     price: 145.0,
//     originalPrice: null,
//     specialOffer: false,
//     image: "https://www.allrecipes.com/thmb/SUs7po94w7k2OwqYDjC3H_ZW3JQ=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/96629-cafe-latte-ddmfs-hero-4x3-0288359d9c37485fa69afe5369dbcf2e.jpg"
//   },
//   {
//     id: "p5",
//     name: "Ecoffee Bamboo Cup 350ml",
//     brand: "ecoffee",
//     category: "thermos",
//     color: "blue",
//     price: 12.5,
//     originalPrice: null,
//     specialOffer: false,
//     image: "https://esquirescoffee.co.uk/wp-content/uploads/2022/08/decaf-vs-reg-coffee-scaled.jpg"
//   },
//   {
//     id: "p6",
//     name: "Acaia Coffee Scale",
//     brand: "acaia",
//     category: "coffee-scales",
//     color: "white",
//     price: 89.99,
//     originalPrice: 99.99,
//     specialOffer: true,
//     badge: "SPECIAL OFFER",
//     image: "https://images.unsplash.com/photo-1511497584788-876760111969?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=7b3f9f8b2a6c1e4d8f9a6b3c1d2e8f4a"
//   },
//   {
//     id: "p7",
//     name: "Fellow Opus Grinder",
//     brand: "fellow",
//     category: "coffee-scales",
//     color: "black",
//     price: 199.0,
//     originalPrice: null,
//     specialOffer: false,
//     image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=8b2c6f9d1a6d3e5f7b0c9a8d6e2f3b1c"
//   },
//   {
//     id: "p8",
//     name: "Ecoffee Reusable Filter 1",
//     brand: "ecoffee",
//     category: "coffee-filters",
//     color: "gray",
//     price: 8.5,
//     originalPrice: null,
//     specialOffer: false,
//     image: "https://images.unsplash.com/photo-1498804103079-a6351b050096?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=1ae3b9c6d4f2b8a9c0e7d3f6b1a2c4d5"
//   },
//   {
//     id: "p9",
//     name: "Ecoffee Reusable Filter 2",
//     brand: "ecoffee",
//     category: "tea-kettles",
//     color: "gray",
//     price: 900,
//     originalPrice: null,
//     specialOffer: false,
//     image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVLfQaF9syeejbpTzrWKbCKcFUSqeKS9Aqqw&s"
//   },
//   {
//     id: "p10",
//     name: "test product IVYKIN",
//     brand: "ivykin",
//     category: "coffee-filters",
//     color: "black",
//     price: 200.2,
//     originalPrice: 29.0,
//     specialOffer: true,
//     badge: "Only Today",
//     image: "https://images.unsplash.com/photo-1503602642458-232111445657?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=9c8b7a6d5e4f3a2b1c0d9e8f7a6b5c4d"
//   },
//   { id: "p11", name: "Chemex Classic", brand: "chemex", category: "pour-over", color: "white", price: 45.0, originalPrice: null, specialOffer: false, image: "https://etimg.etb2bimg.com/photo/113047605.cms" },
//   { id: "p12", name: "Hario V60 Dripper", brand: "hario", category: "pour-over", color: "white", price: 18.0, originalPrice: null, specialOffer: false, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgFanmCOEvrLGeNY7WiCDNs3g5eLqT8ldQeg&s" },
//   { id: "p13", name: "Lodge Pour Over Kettle", brand: "lodge", category: "tea-kettles", color: "green", price: 59.0, originalPrice: null, specialOffer: false, image: "https://www.cariboucoffee.com/wp-content/uploads/2025/10/04-Variety.png" },
//   { id: "p14", name: "Barista Espresso Machine Pro", brand: "acaia", category: "espresso-machines", color: "black", price: 1299.0, originalPrice: 1499.0, specialOffer: true, badge: "SALE", image: "https://res.cloudinary.com/gagan/image/upload/v1594103861/hxg40qa8gzqk6lsvvkcs.jpg" },
//   { id: "p15", name: "Mini Portable Espresso", brand: "aeropress", category: "espresso-machines", color: "red", price: 79.0, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=8d7c6b5a4e3f2d1c0b9a8f7e6d5c4b3a" },
//   { id: "p16", name: "Digital Coffee Scale (Basic)", brand: "acaia", category: "coffee-scales", color: "black", price: 49.99, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1517935706615-2717063c2225?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d" },
//   { id: "p17", name: "Premium Stainless Tumbler 500ml", brand: "asobu", category: "thermos", color: "black", price: 24.99, originalPrice: null, specialOffer: false, image: "https://optimise2.assets-servd.host/worldcoffee-research/production/images/Robusta/Robusta-generic-9.jpeg?w=480&q=82&auto=format&fit=min&crop=focalpoint&fp-x=0.5&fp-y=0.5&dm=1684915833&s=879438c4306b3912891738f2a3dace44" },
//   { id: "p18", name: "Reusable Filter Metal", brand: "ecoffee", category: "coffee-filters", color: "black", price: 11.5, originalPrice: null, specialOffer: false, image: "https://www.marthastewart.com/thmb/3zV1HgB4HytijMHH0I3NfFxJkFE=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/ms-how-to-make-iced-coffee-primary-getty-5f54ee387313494faf1c70c37ae70993.jpg" },
//   { id: "p19", name: "Electric Kettle Rapid", brand: "fellow", category: "tea-kettles", color: "white", price: 129.0, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1540574163026-643ea20ade25?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e" },
//   { id: "p20", name: "Travel Espresso Tumbler", brand: "ivykin", category: "thermos", color: "red", price: 34.0, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1519974719765-e6559eac2575?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b" },
//   { id: "p21", name: "Analog Coffee Scale Pro", brand: "acaia", category: "coffee-scales", color: "white", price: 159.0, originalPrice: 179.0, specialOffer: true, image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=7f6e5d4c3b2a1908f7e6d5c4b3a2910f" },
//   { id: "p22", name: "Pour Over Set - Starter", brand: "hario", category: "pour-over", color: "gray", price: 29.0, originalPrice: null, specialOffer: false, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1eZ_IZeoU0mD1-nKP-R-WmTTmUWtvp26dzg&s" },
//   { id: "p23", name: "Thermos Flask 750ml", brand: "asobu", category: "thermos", color: "blue", price: 19.99, originalPrice: null, specialOffer: false, image: "https://assets.clevelandclinic.org/transform/LargeFeatureImage/977cb940-8bcb-458b-b8c5-c0900c725916/LMC_7858-090520-Mushroom-Coffee-770x533-1_jpg" },
//   { id: "p24", name: "Espresso Tamper", brand: "acaia", category: "espresso-machines", color: "black", price: 25.0, originalPrice: null, specialOffer: false, image: "https://png.pngtree.com/png-clipart/20240810/original/pngtree-flying-cup-of-coffee-with-splash-and-png-image_15739217.png" },
//   { id: "p25", name: "Barista Knock Box", brand: "lodge", category: "espresso-machines", color: "black", price: 39.5, originalPrice: null, specialOffer: false, image: "https://diethood.com/wp-content/uploads/2014/01/Irish-coffee-7.jpg" },
//   { id: "p26", name: "Glass Coffee Server", brand: "chemex", category: "pour-over", color: "white", price: 35.0, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=9f8e7d6c5b4a3928172635443f2e1d0c" },
//   { id: "p27", name: "Mini Milk Frother", brand: "hario", category: "espresso-machines", color: "white", price: 14.0, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=6a5b4c3d2e1f0a9b8c7d6e5f4a3b2c1d" },
//   { id: "p28", name: "Pro Grinder Accessory", brand: "fellow", category: "coffee-scales", color: "black", price: 79.0, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1503602642458-232111445657?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=4e3d2c1b0a9f8e7d6c5b4a3928172635" },
//   { id: "p29", name: "Insulated Coffee Cup", brand: "ecoffee", category: "thermos", color: "green", price: 15.5, originalPrice: null, specialOffer: false, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdMMXqRocLjlNSvE4lM1XmB5L0T-MPS1V6oA&s" },
//   { id: "p30", name: "Pour Over Filters Box", brand: "chemex", category: "coffee-filters", color: "white", price: 9.99, originalPrice: null, specialOffer: false, image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=1400&auto=format&fit=crop&ixlib=rb-4.0.3&s=7b6a5c4d3e2f1a0b9c8d7e6f5a4b3c2d" }
// ];

export const mockProductsData= Array.from({ length: 20 }).map((_, i) => (
    {
      id: `6486`,
      name: "STAINLESS STEEL WINE CHILLER (VPB1)",
      price: 27.20,
      specialOffer: true,
      image: Images.chiller2,
      badge:'Special Offer',
      brand: "aeropress",
      category: "coffee-filters",
      color: "black",
      originalPrice: 29.0,
    }
))

function buildGlobalCounts() {
  const categoryCounts = {};
  const brandCounts = {};
  const colorCounts = {};
  mockProductsData.forEach((p) => {
    categoryCounts[p.category] = (categoryCounts[p.category] || 0) + 1;
    brandCounts[p.brand] = (brandCounts[p.brand] || 0) + 1;
    colorCounts[p.color] = (colorCounts[p.color] || 0) + 1;
  });

  // products facet mapping (productFacetId -> categories)
  const productsFacetMapping = {
    "espresso-makers": ["1"],
    "filters": ["2"],
    "pour-over": ["3"],
    "scales": ["4"],
    "kettles": ["5"],
    "tumblers": ["6"],
  };

  const productsCounts = {};
  Object.keys(productsFacetMapping).forEach((prodId) => {
    let c = 0;
    productsFacetMapping[prodId].forEach((cat) => {
      c += categoryCounts[cat] || 0;
    });
    productsCounts[prodId] = c;
  });

  const prices = mockProductsData.map((p) => p.price).filter((v) => typeof v === "number");
  const globalPriceMin = prices.length ? Math.floor(Math.min(...prices)) : 0;
  const globalPriceMax = prices.length ? Math.ceil(Math.max(...prices)) : 3000;

  return { categoryCounts, brandCounts, colorCounts, productsCounts, globalPriceMin, globalPriceMax };
}

const GLOBAL = buildGlobalCounts();


function filterProducts(query = {}) {
  const { categories = [], brands = [], colors = [], priceMin = 0, priceMax = 3000 } = query;

  return mockProductsData.filter((product) => {
    const categoryMatch = categories.length === 0 || categories.includes(product.category);
    const brandMatch = brands.length === 0 || brands.includes(product.brand);
    const colorMatch = colors.length === 0 || colors.includes(product.color);
    const priceMatch = product.price >= priceMin && product.price <= priceMax;
    return categoryMatch && brandMatch && colorMatch && priceMatch;
  });
}

const productsFacetMapping = {
  "espresso-makers": ["1"],
  "filters": ["2"],
  "pour-over": ["3"],
  "scales": ["4"],
  "kettles": ["5"],
  "tumblers": ["6"],
};

/* ---------- normalize helper ---------- */
function normalizeFacetItems(rawList = [], type = "generic", countsMap = {}) {
  return (rawList || []).map((it) => {
    const id = it.id;
    const name = it.name;
    const count = countsMap[id] ?? it.count ?? 0;
    if (type === "color") return { id, name, hex: it.hex, count };
    return { id, name, count };
  });
}

/* ---------- API implementation ---------- */
export const api = {

  fetchFacets: async (query = {}, { signal } = {}) => {
    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        const categoriesFacet = normalizeFacetItems(mockFacets.categories, "generic", GLOBAL.categoryCounts);
        const productsFacet = normalizeFacetItems(mockFacets.products, "generic", GLOBAL.productsCounts);
        const colorsFacet = normalizeFacetItems(mockFacets.colors, "color", GLOBAL.colorCounts);

     const selectedCategories = Array.isArray(query.categories) ? [...query.categories] : [];
        const selectedProducts = Array.isArray(query.products) ? [...query.products] : [];

        const categoriesFromProducts = selectedProducts.flatMap((prodId) => productsFacetMapping[prodId] || []);
        const effectiveCategoryFilter = Array.from(new Set([...(selectedCategories || []), ...(categoriesFromProducts || [])]));

        const brandFilterQuery = {
          categories: effectiveCategoryFilter,
          brands: [], 
          colors: query.colors || [],
          priceMin: query.priceMin ?? GLOBAL.globalPriceMin,
          priceMax: query.priceMax ?? GLOBAL.globalPriceMax,
        };

        const productsForBrandCounts = filterProducts(brandFilterQuery);

        const brandCounts = {};
        productsForBrandCounts.forEach((p) => {
          brandCounts[p.brand] = (brandCounts[p.brand] || 0) + 1;
        });

        const brandsFacet = normalizeFacetItems(mockFacets.brands, "generic", brandCounts);

        const priceFacet = { min: GLOBAL.globalPriceMin, max: GLOBAL.globalPriceMax };

        const facets = {
          categories: categoriesFacet, // global counts - never zeroed by selecting category
          products: productsFacet, // global counts - never zeroed by selecting product
          brands: brandsFacet, // dynamic counts based on selected categories/products
          colors: colorsFacet, // global counts
          price: priceFacet,
        };

        resolve(facets);
      }, 220);

      if (signal) {
        signal.addEventListener("abort", () => clearTimeout(timeout));
      }
    });
  },

  fetchProducts: async (query = {}, { signal } = {}) => {
    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        const {
          categories = [],
          products = [],
          brands = [],
          colors = [],
          priceMin = 0,
          priceMax = 3000,
          page = 1,
          limit = 12,
          sort = "default",
        } = query;

        // if products facet selected, map them to categories
        let categoriesFromProducts = [];
        if (Array.isArray(products) && products.length) {
          categoriesFromProducts = products.flatMap((prodId) => productsFacetMapping[prodId] || []);
        }
        // union categories filters
        const effectiveCategories = Array.from(new Set([...(categories || []), ...(categoriesFromProducts || [])]));

        // filter
        let filtered = mockProductsData.filter((product) => {
          const categoryMatch = effectiveCategories.length === 0 || effectiveCategories.includes(product.category);
          const brandMatch = brands.length === 0 || brands.includes(product.brand);
          const colorMatch = colors.length === 0 || colors.includes(product.color);
          const priceMatch = product.price >= priceMin && product.price <= priceMax;
          return categoryMatch && brandMatch && colorMatch && priceMatch;
        });

        switch (sort) {
          case "price-low":
            filtered.sort((a, b) => a.price - b.price);
            break;
          case "price-high":
            filtered.sort((a, b) => b.price - a.price);
            break;
          case "name-asc":
            filtered.sort((a, b) => a.name.localeCompare(b.name, "el"));
            break;
          case "name-desc":
            filtered.sort((a, b) => b.name.localeCompare(a.name, "el"));
            break;
          case "newest":
            filtered.sort((a, b) => {
              const aId = parseInt(a.id.replace(/\D/g, "")) || 0;
              const bId = parseInt(b.id.replace(/\D/g, "")) || 0;
              return bId - aId;
            });
            break;
          default:
        }

        const total = filtered.length;
        const totalPages = Math.max(1, Math.ceil(total / (limit || 12)));
        const startIdx = (page - 1) * limit;
        const items = filtered.slice(startIdx, startIdx + limit);

        resolve({ items, total, totalPages, page, limit });
      }, 300);

      if (signal) {
        signal.addEventListener("abort", () => clearTimeout(timeout));
      }
    });
  },
};
